<!--
 * @Description: 
-->
<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.examType"
        placeholder="测试类型"
      >
        <el-option
          v-for="(item, i) in trainTypeData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-input v-model="filters.examName" placeholder="测试名称"></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click="searchFile"></butn>
      <butn title="重置" @click="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
import { getDataMap } from "@/api/sysParam";
export default {
  name: "search",
  components: { butn },
  data() {
    return {
      filters: {},
      trainTypeData: [],
    };
  },
  created() {
    getDataMap("EXAM_TYPE").then((res) => {
      if (!res || res.code != 0) return;
      res.data.splice(0, 0, {
        paramKey: "",
        paramValue: "全部",
      });
      this.trainTypeData = res.data;
    });
  },
  methods: {
    resetData() {
      //重置
      this.filters = {};
      this.searchFile();
    },
    searchFile() {
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
